<template>
  <div>
    <el-card class="mb5">
    <div class="tip01">
      {{ $t('placeOrder.automaticPrinting1') }}
      <el-link :href="$store.getters.expressWmsPluginLink" style="font-size: 16px" type="warning">
        {{ $t('placeOrder.automaticPrinting2') }}
      </el-link>
      {{ $t('placeOrder.automaticPrinting3') }}
    </div>
    <el-form
      ref="ruleFormRef"
      :inline="false"
      :model="queryForm"
      label-position="top"
      size="large"
      @submit.native.prevent
    >
      <el-form-item prop="waybillBagNumber">
        <el-select
          v-model="selectNum"
          style="width: 150px; margin-top: 10px; margin-right: 5px"
          @change="changeNum"
        >
          <el-option :label="$t('GlobalSetObj.scannerNumber')" :value="1" />
          <el-option :label="$t('newOrder.InvoiceKey')" :value="2" />
        </el-select>
        <el-input
          ref="inputRef"
          v-model.trim="currentInputValue"
          :placeholder="
            selectNum === 1 ? $t('GlobalSetObj.scannerNumber') : $t('newOrder.InvoiceKey')
          "
          clearable
          style="width: 350px"
          @keyup.enter.native="arrivedOut"
        />
      </el-form-item>
    </el-form>
    <el-divider style="height: 2px; margin: 22px 0" />
    <el-form>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item>
            <el-select v-model="selectTime" size="small" style="width: 150px">
              <el-option :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
            </el-select>
            <el-input
              v-model="queryForm.waybillNumbers"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              class="textClass"
              style="width: 100%"
              type="textarea"
              @blur="BlockNewline"
              @keydown.enter.native="BlockNewline"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--打印时间-->
          <el-form-item :label="$t('collectionCenter.printTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('collectionCenter.StartTime')"
              range-separator="—"
              size="small"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="timeChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--客户名称-->
          <el-form-item :label="$t('collectionCenter.CustomerName')">
            <el-select
              v-model="queryForm.customerIds"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @clear="getCustomerPage"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--操作网点-->
          <el-form-item :label="$t('collectionCenter.OperationSite')">
            <el-select
              v-model="queryForm.printableSiteIds"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @clear="remoteGetSiteList"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--操作人-->
          <el-form-item :label="$t('collectionCenter.operator')">
            <el-select
              v-model="queryForm.printableUserIds"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              :remote-method="getOperator"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @clear="getOperator"
            >
              <el-option
                v-for="(item, index) in operatorList"
                :key="index"
                :label="item.realName + '（' + item.username + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-bottom: 20px">
        <el-button size="small" type="primary" @click="getSearch">{{
          $t('newOrder.search')
        }}</el-button><!-- 搜索 -->
        <el-button size="small" type="info" @click="reset">{{ $t('newOrder.reset') }}</el-button><!-- 重置 -->
        <el-button size="small" type="success" @click="downloadAll">{{ $t('collectionCenter.allExport') }}
        </el-button>
        <!-- 全部导出 -->
      </div>
    </el-form>
    </el-card>
    <el-card>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      height="600"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="100"
      />
      <el-table-column
        :label="$t('collectionCenter.scanInfo')"
        align="center"
        min-width="180"
        prop="scanInformation"
      />
      <el-table-column
        :label="$t('orderCenterCont.anjunWaybillNumber')"
        align="center"
        min-width="160"
        prop="waybillNumber"
      >
        <template #default="scope">
          <div>{{ scope.row.waybillNumber || '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('collectionCenter.CustomerName')"
        align="center"
        min-width="180"
        prop="customerName"
      />
      <el-table-column
        :label="$t('collectionCenter.printTime')"
        align="center"
        min-width="180"
        prop="printableTime"
      />
      <el-table-column
        :label="$t('collectionCenter.operator')"
        align="center"
        min-width="150"
        prop="printableUserName"
      />
      <el-table-column
        :label="$t('collectionCenter.OperationSite')"
        align="center"
        min-width="150"
        prop="printableSite"
      />
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[50, 100, 200, 400]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 打印面单  -->
    <div style="display: none">
      <pdf ref="pdfPrint" :src="viewUrl" />
    </div>
    <!-- 隐藏提示音 -->
    </el-card>
    <div v-show="false">
      <audio ref="errRef" :src="errorMp3" controls="controls" />
      <audio ref="okRef" :src="okMp3" controls="controls" />
    </div>
    <el-dialog
      :before-close="handleClose"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="printTipsVisible"
      width="30%"
    >
      <div class="printTips_class">
        <div class="printTips_title">
          <!-- 请选择需要打印的运单号 -->
          {{ $t('collectionCenter.selectWaybill') }}
        </div>
        <el-radio-group v-model="checkList">
          <!-- 原单号 -->
          <el-radio :label="1">{{ $t('collectionCenter.originalWaybill') }}：{{ printTips.forwardWaybillNumber }}
          </el-radio>
          <!-- 退件单号 -->
          <el-radio :label="2">{{ $t('collectionCenter.returnNoteNum') }}：{{ printTips.waybillNumber }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button size="small" @click="handleClose">{{ $t('roleManage.cancel') }}</el-button>
        <!-- 确认 -->
        <el-button size="small" type="primary" @click="submitPr">{{ $t('roleManage.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <printTipsCom ref="printTipsComRef" @autoPrint="submitPr" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList.js';
import { getUserPage } from '@/api/user';
import { siteFuzzyQuery } from '@/api/lanshou';
import { apiCustomerPage } from '@/api/customer';
import {
  checkWaybillNumber,
  getByInvoiceSecretKey,
  quickOrderChange,
  waybillPrintableExportAll,
  waybillPrintablePage
} from '@/api/automaticSorting';
import { batchPdfDownload } from '@/utils/PDF_util';
import pdf from 'vue-pdf-messy-code-fix';
import { apiStartUp, autoPrint } from '@/api/serialPort';
import printTipsCom from './component/printTipsCom.vue';

const okMp3 = 'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/su.wav';
const errorMp3 =
  'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/print_error.wav';
export default {
  name: 'QuickOrderChange',
  components: {
    pdf,
    printTipsCom
  },
  data() {
    return {
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      operatorList: [], // 操作人列表
      siteList: [], // 操作网点列表
      customerList: [], // 客户列表
      timeValue: [],
      selectTime: 1,
      selectNum: 1,
      checkList: '',
      printTipsVisible: false,
      printTips: {
        forwardWaybillNumber: '',
        waybillNumber: ''
      },
      viewUrl: '',
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 50,
        pageNumber: 1,
        total: 0,
        waybillBagNumber: '',
        invoiceSecretKeys: '',
        waybillNumbers: '',
        beginPrintDate: '',
        endPrintDate: '',
        customerIds: [],
        printableSiteIds: [],
        printableUserIds: []
      },
      tableData: [],
      okMp3,
      errorMp3,
      resultData: []
    };
  },
  computed: {
    currentInputValue: {
      get() {
        return this.selectNum === 1
          ? this.queryForm.waybillBagNumber
          : this.queryForm.invoiceSecretKeys;
      },
      set(val) {
        if (this.selectNum === 1) {
          this.queryForm.waybillBagNumber = val;
        } else {
          this.queryForm.invoiceSecretKeys = val;
        }
      }
    }
  },
  activated() {
    this.$nextTick((_) => {
      this.$refs.inputRef?.focus();
    });
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.$nextTick((_) => {
      this.$refs.inputRef?.focus();
    });
    this.getCustomerPage('');
    this.remoteGetSiteList('');
    this.getOperator('');
    this.reset(); // 重置+查询
  },
  methods: {
    BlockNewline() {
      if (this.queryForm.waybillNumbers) {
        let lines = this.queryForm.waybillNumbers
          .split('\n')
          .filter((line) => line && line.trim())
          .map((line) => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.queryForm.waybillNumbers = lines.join('\n');
        console.log('waybillNumbers', this.queryForm.waybillNumbers);
      }
    },
    timeChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.beginPrintDate = '';
        this.queryForm.endPrintDate = '';
        this.$message.warning(this.$t('newOrder.timeIsNotNull'));
        return;
      }
      this.queryForm.beginPrintDate = val[0];
      this.queryForm.endPrintDate = val[1];
    },
    // 客户名称列表
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 操作网点列表
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 操作人数据
    getOperator(name) {
      const queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          realName: name
        }
      };
      getUserPage(queryForm).then((res) => {
        if (res.code === 200) {
          this.operatorList = res.data.records;
        }
      });
    },
    downloadAll() {
      if (this.tableData.length <= 0) {
        // '无可导出数据'
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
        return;
      }
      const data = {
        waybillNumbers: this.queryForm.waybillNumbers
          ? this.queryForm.waybillNumbers.split('\n')
          : [],
        invoiceSecretKeys: [],
        beginPrintDate: this.queryForm.beginPrintDate,
        endPrintDate: this.queryForm.endPrintDate,
        customerIds: this.queryForm.customerIds,
        printableSiteIds: this.queryForm.printableSiteIds,
        printableUserIds: this.queryForm.printableUserIds
      };
      waybillPrintableExportAll(data).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    reset() {
      const d = new Date();
      const day = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [day + ' 00:00:00', day + ' 23:59:59'];
      this.queryForm = {
        pageSize: 50,
        pageNumber: 1,
        total: 0,
        waybillBagNumber: '',
        invoiceSecretKeys: '',
        waybillNumbers: '',
        beginPrintDate: day + ' 00:00:00',
        endPrintDate: day + ' 23:59:59',
        customerIds: [],
        printableSiteIds: [],
        printableUserIds: []
      };
      this.selectTime = 1;
      this.getSearch();
    },

    changeNum() {
      // 切换时清空两个值
      this.queryForm.waybillBagNumber = '';
      this.queryForm.invoiceSecretKeys = '';
      // 保持输入框焦点
      this.$nextTick(() => {
        this.$refs.inputRef?.focus();
      });
    },
    handleClose() {
      this.printTipsVisible = false;
      this.checkList = '';
      this.printTips = {
        forwardWaybillNumber: '',
        waybillNumber: ''
      };
    },
    printedSheet(url) {
      const labelList = [url];
      // 手动显示加载中动画
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$i18n.t('orderCenterCont.DesperatelyLoading'), // '拼命加载中',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      batchPdfDownload(labelList)
        .then((res) => {
          this.viewUrl = res;
          setTimeout(() => {
            this.$refs.pdfPrint.print();
          }, 300);
        })
        .finally(() => {
          loading.close();
        });
    },
    // 查询
    getSearch() {
      if (
        !this.queryForm.waybillBagNumber &&
        !this.queryForm.invoiceSecretKeys &&
        (!this.timeValue || this.timeValue.length <= 0)
      ) {
        this.$message.warning(this.$t('newOrder.timeIsNotNull'));
        return;
      }
      this.queryForm.pageNumber = 1;
      this.page();
    },
    page() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          waybillNumbers: this.queryForm.waybillNumbers
            ? this.queryForm.waybillNumbers.split('\n')
            : [],
          invoiceSecretKeys: [],
          beginPrintDate: this.queryForm.beginPrintDate,
          endPrintDate: this.queryForm.endPrintDate,
          customerIds: this.queryForm.customerIds,
          printableSiteIds: this.queryForm.printableSiteIds,
          printableUserIds: this.queryForm.printableUserIds
        }
      };
      waybillPrintablePage(data).then((res) => {
        if (res.status === 'OK') {
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        }
      });
    },
    // 扫描
    arrivedOut() {
      const hasBagNumber = this.queryForm.waybillBagNumber && this.selectNum === 1;
      const hasInvoiceKey = this.queryForm.invoiceSecretKeys && this.selectNum === 2;

      if (hasBagNumber) {
        checkWaybillNumber(this.queryForm.waybillBagNumber).then((res) => {
          if (res.code === 200) {
            if (res.data) {
              this.printTipsVisible = true;
              this.printTips = {
                forwardWaybillNumber: res.data.forwardWaybillNumber,
                waybillNumber: res.data.waybillNumber
              };
            } else {
              this.submitPr();
            }
          }
        });
      } else if (hasInvoiceKey) {
        getByInvoiceSecretKey(this.queryForm.invoiceSecretKeys).then((res) => {
          if (res.code === 200) {
            if (res.data) {
              if (res.data.length > 1) {
                console.log(res.data, 'res.data');
                const dataList = [];
                res.data.forEach((item) => {
                  const obj = {
                    waybillNumber: item,
                    invoiceAccessKey: this.queryForm.invoiceSecretKeys
                  };
                  dataList.push(obj);
                });
                this.$refs.printTipsComRef.showTip(dataList);
              } else {
                this.submitPr();
              }
            }
          }
        });
      } else {
        this.getSearch();
      }
    },
    submitPr() {
      let waybillNumber = '';
      if (this.printTips.forwardWaybillNumber) {
        waybillNumber =
          this.checkList === 1
            ? this.printTips.forwardWaybillNumber
            : this.checkList === 2
              ? this.printTips.waybillNumber
              : '';
        if (!waybillNumber) {
          this.$message.warning(this.$t('GlobalSetObj.pleaseChoose'));
          return;
        }
      } else {
        waybillNumber =
          this.selectNum === 1 ? this.queryForm.waybillBagNumber : this.queryForm.invoiceSecretKeys;
      }
      const data = {
        waybillNumbers: [],
        invoiceSecretKeys: []
      };
      if (this.selectNum === 1) {
        data.waybillNumbers = [waybillNumber];
      } else {
        data.invoiceSecretKeys = [waybillNumber];
      }
      quickOrderChange(data)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.resultData = res.data;
            this.printFun();
          }
        })
        .catch(() => {
          this.$nextTick((_) => {
            this.$refs.inputRef?.select();
          });
        });
    },
    // 触发打印接口
    async printFun() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('scripting.printingWaybillPleaseWait'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        const res1 = await apiStartUp();
        if (res1.code !== 200) {
          this.$refs.errRef.play();
          this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
          this.$nextTick(() => {
            this.$refs.inputRef?.select();
          });
          return;
        }

        const printDataList = this.resultData;

        for (const item of printDataList) {
          try {
            const resPrint = await autoPrint(item.labelUrl);
            if (resPrint.code === 200) {
              await this.$refs.okRef.play();
            } else {
              throw new Error('打印失败');
            }
          } catch (err) {
            await this.$refs.errRef.play();
            this.$message.error(this.$t('GlobalSetObj.PrintFailure'));
          }
        }
        this.$message.success(this.$t('collectionCenter.printSuc'));
        this.queryForm.waybillBagNumber = '';
        this.queryForm.invoiceSecretKeys = '';
        this.$nextTick(() => {
          this.$refs.inputRef?.focus();
        });
        this.getSearch();
        this.printTipsVisible = false;
      } catch (e) {
        this.$refs.errRef.play();
        this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
        this.$nextTick(() => {
          this.$refs.inputRef?.select();
        });
      } finally {
        loading.close();
      }
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.page();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.page();
    }
  }
};
</script>

<style scoped>
.textClass >>> ::v-deep .el-textarea__inner {
  max-height: 200px;
}

.dialog-footer {
  text-align: center;
}

.dialog-footer >>> .el-button:first-child {
  margin-right: 20px;
}

.printTips_class {
  padding-top: 10px;
  padding-left: 40px;
  box-sizing: border-box;
}

.printTips_title {
  margin-bottom: 10px;
}

.printTips_class >>> .el-radio-group .el-radio {
  display: block !important;
  margin-bottom: 5px;
}

.app-container >>> .el-dialog__body {
  padding: 10px 20px;
}

.tip01 {
  background-color: #ecf5ff;
  color: #409eff;
  padding: 10px;
  font-size: 14px;
  border-radius: 5px;
}
</style>
